import { UserContext } from "@context/user";
import { confirmAlert } from "@helpers/toast";
import { destroyUserSession, getItemFromStore, isSuperAdminUrl, loginViaSuperadmin } from "@helpers/utils";
import { useContext } from "react";
import usePanelAbility from "./use-panel-ability";

const useLogout = () => {
    const { handleUserData } = useContext(UserContext);
    const { handlePanelAbility } = usePanelAbility();

    const handleAuthLogout = async () => {
        handleUserData();
        if (loginViaSuperadmin() && isSuperAdminUrl()) {
            localStorage.clear();
            destroyUserSession();           
            window.location.pathname = "/superadmin";
            return;
        }
        if (loginViaSuperadmin() && !isSuperAdminUrl()) {
            localStorage.removeItem("token");
            localStorage.removeItem("userInfo");
            localStorage.removeItem("ability");
            const superadminData = getItemFromStore("superadminInfo");
            handlePanelAbility({ userInfo: superadminData });
            window.location.pathname = "/superadmin/organizations";
        } else {
            localStorage.clear();
            destroyUserSession();
            window.location.pathname = "/login";
        }
    };

    const handleLogout = async () => {
        await confirmAlert({
            title      : "Confirm Logout",
            text       : "Are you sure you want to log out?",
            imageHeight: 100,
            preConfirm : () => { handleAuthLogout(); }
        });
    };

    return {
        handleLogout,
        handleAuthLogout
    };
};

export default useLogout;
